export const TOKENS = {
  // Color (ok on dark bg, WCAG AA for UI text)
  bg0: "#0B0D12",        // main background
  bg1: "#0F1724",        // panel / lane base
  grid: "#132035",       // subtle playfield grid
  text: "#E6EDF7",
  accent: "#7EE787",     // primary accent (notes/hits)
  accent2: "#9A7FF0",    // secondary (sliders)
  warn: "#FFB86B",
  danger: "#FF6B6B",
  hairline: "rgba(255,255,255,0.16)", // subtle borders
  muted: "rgba(255,255,255,0.08)",    // muted surfaces
  // Glow intensities
  glowWeak: 0.3,
  glowMed: 0.65,
  glowStrong: 1.0,
  // Geometry
  stage: { w: 900, h: 1600 }, // 9:16 logical
  note: { r: 52, rim: 4 },    // circle-style note
  approach: { width: 6 },
  cursor: { r: 20 },
  // Timing UI
  hitWindows: { _300: "#7EE787", _100: "#FFB86B", _50: "#FF6B6B" },
  // Typography
  fontUI: "Inter, ui-sans-serif, system-ui",
  fontMono: "JetBrains Mono, ui-monospace, monospace",
} as const;
